import { IRootState } from "../../store";

export const selectBanners = (state: IRootState) => state.banners.banners;
